import type { RegionType } from "lib/apollo/types"
import isAbsoluteUrl from "is-absolute-url"
import { getStore } from "lib/apolloClient"

export const navigateTo = (url: string, region?: RegionType): void => {
  if (typeof window === "undefined") return
  const locale = region ?? getStore()
  const isAbsolute = isAbsoluteUrl(url)
  const href = locale === "us" ? `/us${url}` : url
  window.location.href = isAbsolute ? url : href
}
